import KUData from './KUData'
import DocsCard from './components/DocsCard/DocsCard'

export { KUData, DocsCard }
